import { Changeability } from "@opstel/query/v2/models/action";
import { useToggleChangeability } from "../../SBDAction/useToggleChangeability";

export interface LockButtonProps {
  readonly actionId: string;
  readonly changeability: Changeability;
}

export function LockButton({ actionId, changeability }: LockButtonProps) {
  const { canToggleChangeabilityQuery, toggleChangeability } = useToggleChangeability({
    actionId,
    currentChangeability: changeability,
  });

  if (canToggleChangeabilityQuery.isFetching || canToggleChangeabilityQuery.isError) {
    return <LockIcon changeability={changeability} />;
  }

  if (canToggleChangeabilityQuery.data?.canUpdate) {
    return (
      <tractie-button level="tertiary" icon-only={true} onClick={toggleChangeability}>
        <LockIcon changeability={changeability} />
      </tractie-button>
    );
  }

  return (
    <tractie-tooltip has-arrow>
      <LockIcon changeability={changeability} slot="invoker" />;
      <span slot="content">{canToggleChangeabilityQuery.data?.description}</span>
    </tractie-tooltip>
  );
}

interface LockIconProps {
  readonly changeability: Changeability;
  readonly slot?: string;
}

function LockIcon({ changeability, slot }: LockIconProps) {
  return (
    <tractie-icon
      data-testid="icon"
      name={changeability === "Open" ? "lock-open" : "lock"}
      slot={slot}
    />
  );
}
